import { Button, Input, Modal, ModalProps } from "antd";
import { MyColor } from "../../config/myStyle";
import { useEffect, useRef, useState } from "react";
import { OTPRef } from "antd/es/input/OTP";
import { useTranslation } from "react-i18next";

type LoginPasscodeProps = {
  onPasscode(passcode: string): void
  modalProps: ModalProps
}

const LoginPasscode = (props: LoginPasscodeProps) => {
  const { t } = useTranslation();
  const [passcode, setPasscode] = useState('');
  const inputRef = useRef<OTPRef>(null);

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <Modal
      {...props.modalProps}
      title={null}
      closable={false}
      footer={null}
      width={420}
      style={{ top: 180, maxWidth: "calc(100vw - 48px)" }}
      styles={{
        container: {
          backgroundColor: MyColor.bg,
          padding: 0,
        }
      }}
    >
      <div className="flex flex-col p-[20px]" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div
          className="flex-1"
          style={{
            textAlign: 'center',
            fontSize: 18,
            color: MyColor.blue,
            width: '100%',
            maxWidth: 260,
            fontWeight: 600,
          }}
        >
          {t("login.passcode_modal_tip")}
        </div>
        <Input.OTP
          ref={inputRef}
          className="mt-[25px]"
          styles={{
            input: {
              height: 40,
              width: 40,
              margin: 5,
            }
          }}
          length={4}
          autoFocus={true}
          type='number'
          onInput={e => setPasscode(e.join(''))}
        />
        <Button
          type="default"
          style={{
            width: "100%",
            borderRadius: 30,
            background: MyColor.red,
            color: "#fff",
            height: 48,
            fontSize: 20,
            fontWeight: 500,
            marginTop: 50,
            letterSpacing: 1,
            border: "none",
            boxShadow: "0 2px 8px #eecbe0"
          }}
          onClick={() => props.onPasscode(passcode)}
        >
          {t("login.login_button")}
        </Button>
      </div>
    </Modal>
  );
};

export default LoginPasscode;
